module.exports = __webpack_public_path__ + "87e7500d0106df5a3538fcb4da205756.png";